import Model from "./base/model";

class nfFile extends Model{
  resourceName() {
    return "nf_files";
  }

  fields() {
    return {
      path: "",
      name: "",
      nf_path: "",
      nf_name: "",
      number: "",
      serie: "",
      value: "",
      weight: "",
      volume: "",
      volume_type: "",
      is_additional: "",
      created_at: "",
      stored_by: "",
      storedBy: "",
      is_repeated: "",
      order: { jsonApi: "hasOne", type: "orders"},
      invoices_key: "",
      are_repeated: ""
    }
  }

  async isRepeated(nfKey) {
    return this.request(
      this.resourceName() + `/${nfKey}`,
      'GET',
      {},
    );
  }
  
  async areRepeated(invoices_key) {
    return this.request(
      this.resourceName() + `/are_repeated`,
      'POST',
      null,
      invoices_key,
    );
  }
}

export default new nfFile();
